import React from 'react';
import AutomationIcon from './AutomationIcon';
import { HOW_IT_WORKS_STEPS } from '../constants/automationRules';

// Deliberately not headings: the page runs h2 → h3 (sections) → h4 (rail arms), and
// heading-ing three step cards would either skip a level or compete with the section
// headings they precede. An ordered list already carries "these happen in sequence".
const AutomationHowItWorks = () => (
  <ol className="automation-rules__steps" aria-label="How it works" data-testid="how-it-works">
    {HOW_IT_WORKS_STEPS.map((step) => (
      <li className="automation-rules__step" key={step.eyebrow}>
        <span className="automation-rules__step-eyebrow">{step.eyebrow}</span>
        <span className="automation-rules__step-title">
          <span className="automation-rules__step-icon" aria-hidden="true">
            <AutomationIcon name={step.icon} />
          </span>
          {step.title}
        </span>
        <p className="automation-rules__step-body">{step.body}</p>
      </li>
    ))}
  </ol>
);

export default AutomationHowItWorks;
